var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-checkbox',{on:{"change":function($event){return _vm.handleCheckSlot()}},model:{value:(_vm.checked),callback:function ($$v) {_vm.checked=$$v},expression:"checked"}})
}
var staticRenderFns = []

export { render, staticRenderFns }